import React from "react"
import { FormattedMessage } from "react-intl"

import { Box, H1, P } from "@bullseye/components"

import SignUpButton from "../SignUpButton"

const HankMember = () => (
  <Box className="flex flex-col items-center py-20 g-1 md:px-4">
    <Box className="max-w-[600px] flex-col items-center px-4">
      <H1 className="pb-2 text-center text-brand-indigo-1">
        <FormattedMessage id="home.members.title.line1" />{" "}
        <Box className="hidden md:flex" />
        <H1 className="text-brand-orange-1">
          <FormattedMessage id="home.members.title.line2" />
        </H1>
      </H1>
      <P className="mb-8 text-center" size="lg">
        As a Hank member—and as part of the Wider Circle family—you&apos;ll join
        a welcoming community of people who are all here for the same reason: to
        connect. You&apos;ll get access to easy-to-join activities and simple
        features that make starting new friendships easy and natural.
      </P>
      <SignUpButton>
        <FormattedMessage id="general.getStarted.free" />
      </SignUpButton>
    </Box>
  </Box>
)

export default HankMember
